import styled from "styled-components";

import backgroundImg from "../../../../image/home/company-purchase-background.png";
import borderBotomImg from "../../../../image/assets/border-bottom.svg";

import ButtonComponent from "../../button";

export const StyledSection = styled.section`
  padding: 3rem 0 6rem;
  @media screen and (max-width: 768px) {
    padding: 2rem 0 3rem;
  }
  background: url(${backgroundImg}) no-repeat bottom;
  background-size: cover;
  color: rgba(256, 256, 256, 0.8);
  p {
    line-height: 3.5rem;
    font-size: 2rem;
    max-width: 380px;
    @media screen and (max-width: 768px) {
      font-size: var(--font-size-sm);
      line-height: 2rem;
    }
    mark {
      color: #f7db46;
      background: url(${borderBotomImg}) no-repeat bottom;
      background-size: contain;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  justify-content: center;
  height: 100%;
`;

export const StyledButton = styled(ButtonComponent)`
  width: fit-content;
  padding: 2rem 2.5rem;
  color: var(--tertiary-color);
  font-size: var(--font-size-xl);
  font-weight: 500;
  @media screen and (max-width: 768px) {
    padding: 1rem 1.5rem;
    font-size: var(--font-size-sm);
  }
`;
